@if (stumpDutyInfo()) {
  <br>
  <div class="row">
    <div class="col-12">
      <app-alert [closable]="false" alertTitle="Uwaga!">
        Składasz wniosek bez uiszczenia opłaty! Opłata musi zostać uiszczona przed odbiorem dokumentów.
      </app-alert>
    </div>
  </div>
}
